import { useQuery } from 'react-query';
import { getSupportArticles, getSupportCategories, getSupportSubCategories } from './queries';

export const useSupportCategories = () => {
  return useQuery(['support-categories'], () => getSupportCategories(), {
    retry: false,
  });
};

export const useSupportArticles = () => {
  return useQuery(['support-articles'], () => getSupportArticles(), {
    retry: false,
  });
};

export const useSupportCategory = () => {
  return useQuery(['support-category'], () => getSupportSubCategories(), {
    retry: false,
  });
};
